module.exports = __webpack_public_path__ + "static/media/DanielOcampo.dc2ed789.jpg";